import React, { Component } from "react";
import { Row, Col, Alert } from 'reactstrap';
import opRight from '../../imgs/op_right.png'

export class SanQiHuYuInviteRejectSuccess extends Component {
    render() {
        return (
            <div>
                <Row>
                    <Col sm="12" md={{ size: 8, offset: 2 }}>
                        <div style={{ textAlign: "center", padding: "15px" }}>
                            <img alt={"Well Done"} src={opRight} style={{ width: "100px" }} />
                        </div>
                        <Alert color="success">
                            <h4 className="alert-heading">操作成功！</h4>
                            <hr />
                            <p className="mb-0">请点击右上角关闭此页面，感谢您的反馈。</p>
                        </Alert>
                    </Col>
                </Row>
            </div>
        )
    }
}